import IoC from '@rawlplug/inversion-of-control/src/IoC';
const ioc = new IoC();
export default ioc;
